export const getScrolledPercentage = (scrollContent: HTMLElement) => {
  const height = scrollContent.clientHeight;
  const scrollHeight = scrollContent.scrollHeight - height;
  const scrollTop = scrollContent.scrollTop;
  const scrolledPercent = Math.floor(scrollTop / scrollHeight * 100);

  return scrolledPercent;
};

export const loadScript = (src: string, async = true): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    document.head.appendChild(script);
  });
};
